/** Lesson content list cache; invalidate after bulk JSON import from the module page. */
export const lessonContentCache = {
  lessons: null,
  lessonId: null,
  page: 1,
  totalPages: 1,
  totalCount: 0,
};

export function invalidateLessonContentCache() {
  lessonContentCache.lessons = null;
  lessonContentCache.lessonId = null;
  lessonContentCache.page = 1;
  lessonContentCache.totalPages = 1;
  lessonContentCache.totalCount = 0;
}

function coerceNumber(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

/**
 * Optimistically bump quiz counts for a lesson-content card in the cached list.
 * Makes Lesson Content show updated quiz count immediately when navigating back from Quiz page.
 */
export function bumpLessonContentQuizCount(contentId, delta = 1) {
  if (!contentId || !Array.isArray(lessonContentCache.lessons)) return;
  const targetId = String(contentId);

  lessonContentCache.lessons = lessonContentCache.lessons.map((item) => {
    const id = item?.id ?? item?._id ?? item?.content_id;
    if (id == null || String(id) !== targetId) return item;

    const current =
      coerceNumber(item?.child_count) ??
      coerceNumber(item?.children_count) ??
      (Array.isArray(item?.children) ? item.children.length : null) ??
      (Array.isArray(item?.questions) ? item.questions.length : null) ??
      0;

    const next = Math.max(0, current + Number(delta || 0));

    return {
      ...item,
      child_count: next,
      children_count: next,
    };
  });
}
